import { LOADING, LOADING_SUCCESS } from './mutation-types';


const loader = {
  state: {
    loading: false,
  },
  mutations: {
    [LOADING](state) {
      state.loading = true;
    },
    [LOADING_SUCCESS](state) {
      state.loading = false;
    },
  },
};

export default loader;



// WEBPACK FOOTER //
// ./src/store/loader.js